import React from 'react'
import { RowLayout } from '../RowLayout'
import { CaseCommonDataType, CaseMERespType, DestinationType } from '../../models'
import { strToDateFormat } from '../../helpers'
import { translation } from '../../i18n'

type healthProblemOverviewRespType = {
  caseCommon?: CaseCommonDataType
  caseME?: CaseMERespType
  destinations: DestinationType[]
} & translation

export const HealthProblemOverview = (
  params: healthProblemOverviewRespType
) => {
  const t = params.t
  return (
    <>
      <RowLayout
        text={t('thirdPg.occurredOn.label')}
        data={strToDateFormat(params.caseCommon?.occurredOn)}
      />
      <RowLayout
        text={t('thirdPg.destination.label')}
        data={params.destinations.find(
          (item: DestinationType) =>
            item.code === params?.caseCommon?.destination
        )?.name ?? params?.caseCommon?.destination}
      />
      <RowLayout text={t('thirdPg.resort.label')} data={params.caseCommon?.resort} />
      <RowLayout text={t('thirdPg.place.label')} data={params.caseCommon?.place} />
      <RowLayout
        text={t('thirdPg.assistance.label')}
        // @ts-ignore
        data={params.caseCommon?.assistance ? t('yes') : t('no')}
      />
      {!params.caseCommon?.assistance && (
        <RowLayout
          text={t('thirdPg.assistanceDesc.label')}
          data={params.caseCommon?.assistanceDesc}
        />
      )}
      <RowLayout
        text={t('thirdPg.transport.label')}
        // @ts-ignore
        data={params.caseME?.transport ? t('yes') : t('no')}
      />
      {params.caseME?.transport && (
        <RowLayout
          text={t('thirdPg.transportType.label')}
          data={t(`thirdPg.transportType.code.${params.caseME?.transportType}`)}
        />
      )}
      {params.caseCommon?.description !== '' && (
        <RowLayout
          text={t('thirdPg.description.label')}
          data={params.caseCommon?.description}
        />
      )}
      {params.caseME?.treatmentTypes?.includes('IP') && (
        <React.Fragment>
          <RowLayout
            text={t('thirdPg.hospitDateFrom.label')}
            data={strToDateFormat(params.caseME?.hospitDateFrom)}
          />
          {params.caseME?.hospitDateTo && (
            <RowLayout
              text={t('thirdPg.hospitDateTo.label')}
              data={strToDateFormat(params.caseME?.hospitDateTo)}
            />
          )}
        </React.Fragment>
      )}
    </>
  )
}
